import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';

@Metamodel.model({})
export class ParameterConfig<T extends string = string> extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    public name: T;

    @Metamodel.attribute({
        templatable: true,
        accepts: ['Any'],
        association: 'VALUE'
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public value: any;

    // eslint-disable-next-line
    public type: string;

    public direction: string;

    public size?: number;

    public defaultValue?: string;

    public required?: boolean = false;

    public valid?: boolean = true;
}
